import React from "react";
import "./Bestitsolutions.scss";

export default function Bestitsolutions() {
  return (
    <section className="bestit-section">
      <div className="overlay"></div>
      <div className="content">
        <h1>
        Next-Level IT Solutions, <br />  Made Simple 
        </h1>
      </div>




          </section>

  );
}